/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var GraduationCapOutlineIcon = function GraduationCapOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5634 3.78355C11.4589 3.29513 12.5411 3.29513 13.4366 3.78355L21.3899 8.12171C22.0849 8.5008 22.0847 9.49882 21.3895 9.87767L19 11.18V15.993C19 16.7247 18.6004 17.3981 17.9581 17.7486L13.4371 20.2157C12.5414 20.7045 11.4586 20.7045 10.5629 20.2157L6.04194 17.7486C5.39962 17.3981 5 16.7247 5 15.993V11.18L3 10.09V17H1V10.1872C1 9.45535 1.39977 8.78191 2.0423 8.43145L10.5634 3.78355ZM5.18 8.99997L12 12.72L18.82 8.99997L12 5.27997L5.18 8.99997ZM7 15.99L12 18.72L17 15.99V12.27L13.4377 14.215C12.5416 14.7042 11.4583 14.7042 10.5623 14.215L7 12.27V15.99Z"
  }));
};
export default GraduationCapOutlineIcon;